// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".indicator{position:absolute;display:block;width:12px;height:12px;bottom:-2px;right:-2px;border-radius:6px;background:#b1b8c4;z-index:2}.indicator.green{border:2px solid #fff;background:#00bfa5}.indicator.red{border:2px solid #fff;background:#ff5b61}", ""]);
// Exports
module.exports = exports;
